var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAndroidAuto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.9506 16.5659C1.2594 16.5659 0.699219 16.0058 0.699219 15.3146C0.699219 15.087 0.759631 14.8736 0.866331 14.69L8.79042 0.928014C9.00618 0.553777 9.41101 0.301147 9.87469 0.301147C10.3384 0.301147 10.7432 0.553777 10.959 0.928014L18.8831 14.69C18.9898 14.8736 19.0502 15.087 19.0502 15.3146C19.0502 16.0058 18.49 16.5659 17.7988 16.5659H1.9506Z",
    fill: "#03A9F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.875 6.13989V16.566H20.3011L9.875 6.13989Z",
    fill: "url(#paint0_linear_45316_8613)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.79042 0.928014L0.866331 14.69C0.759631 14.8736 0.699219 15.087 0.699219 15.3146C0.699219 16.0058 1.2594 16.5659 1.9506 16.5659H9.87469V0.301147C9.41101 0.301147 9.00618 0.553777 8.79042 0.928014Z",
    fill: "#039BE5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.87409 6.13989L16.9634 18.6513L16.546 19.0687L9.87331 16.5667L3.20059 19.0687L2.7832 18.6513L9.87409 6.13989Z",
    fill: "#F1F1F1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.87578 6.13989L16.9651 18.6513L16.5477 19.0687L9.875 16.5667",
    fill: "#E1E1E1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_45316_8613",
    x1: 7.6377,
    y1: 10.0802,
    x2: 18.6538,
    y2: 16.3368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A237E",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A237E",
    stopOpacity: 0.02
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidAuto);
export default __webpack_public_path__ + "static/media/android-auto.97fcbdf92e30ba7ebddde9944f0e968c.svg";
export { ForwardRef as ReactComponent };